/**
	***************************************************************
	* This class contain a general methods that help to handle
	* type in typeScript.
	*
	*  Written by: Dana Moshe
	***************************************************************
	*/
export class TypeHelper {

	static STATIC_SUFFIX:string = "_TYPE";

	/**
		* Change prototype for object, and for the entire object that this object contains.
		* @param obj The prototype change for this object.
		* @param type Name of class (the new prototype).
		* @returns None.
		*/
	public static changePrototype<T>(obj:any, type:{ new ():T; }) {

		if (obj == null) {
			return;
		}

		if (obj.constructor === Object) {

			// Change prototype.
			if (obj.__proto__) {
				obj.__proto__ = type.prototype;
			} else {
				// IE9 fix - copy object methods from the prototype to the new object
				/* tslint:disable */
				for (let prop in type.prototype) {
					obj[prop] = type.prototype[prop];
				}
				/* tslint:enable */
			}

			// For each object in the current object have a field of the type.
			// The name of the field is end with the constant STATIC_SUFFIX ("_TYPE").
			for (let staticType in type.prototype.constructor) {
				if (staticType.indexOf(this.STATIC_SUFFIX, staticType.length - this.STATIC_SUFFIX.length) > 0) {
					let nextType = type.prototype.constructor[staticType];
					let nextObj = obj[staticType.substr(0, staticType.length - this.STATIC_SUFFIX.length)];
					this.changePrototype(nextObj, nextType);
				}
			}
		} else if (Array.isArray(obj)) { // Change prototype for array.
			for (let i = 0; i < obj.length; i++) {
				this.changePrototype(obj[i], type);
			}
			(<any>obj).itemsType = type;
		}
	}
}
